import { Col, Divider, Row } from 'antd';
import React from 'react';
import { SupportTier } from '../../../models/support-tier-interface';

interface SupportProps {
  supportDetails: SupportTier | undefined;
}

export default function Support({ supportDetails }: SupportProps) {
  if (!supportDetails) return null;

  return (
    <>
      <Row align='middle'>
        <Col span={6}>Support</Col>
        <Col span={18} style={{ textAlign: 'right' }}>
          <b>{supportDetails.name}</b>
          <br />
          {supportDetails.days}
          <br />
          {supportDetails.timeString}
          <br />
          {supportDetails.phone && supportDetails.email
            ? 'Phone & Email'
            : supportDetails.phone
            ? 'Phone'
            : supportDetails.email
            ? 'Email'
            : ''}
          <br />
        </Col>
      </Row>
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
    </>
  );
}
